import React from 'react';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import theme from './SelectStyleBtn.module.scss';

export const SelectedIndicator: React.FC = () => {
    return (
        <div className={theme.selectedIndicator}>
            <FontAwesomeIcon icon={faCheck} color="var(--rui-color-success)" />
            <Trans>Selected</Trans>
        </div>
    );
};

